// extracted by mini-css-extract-plugin
module.exports = {"range":"styles-mod--range--VHSVm","range__element":"styles-mod--range__element--2i9nj","range__persons":"styles-mod--range__persons--5fSw-"};